import { ValueProvider } from '@angular/core';
import { TRANSLOCO_CONFIG, translocoConfig } from '@ngneat/transloco';

export const provideTranslocoConfig = (prodMode = true): ValueProvider => ({
    provide: TRANSLOCO_CONFIG,
    useValue: translocoConfig({
        availableLangs: ['vi', 'en', 'ja', 'zh-cn'],
        defaultLang: 'vi',
        // Remove this option if your application doesn't support changing language in runtime.
        reRenderOnLangChange: true,
        prodMode
    })
});
